import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  MODULE_REGISTRATION,
  MODULE_REGISTRATION_ALL,
  MODULE_REGISTRATION_CREATE,
  MODULE_REGISTRATION_DELETE,
  MODULE_REGISTRATION_LIST,
  MODULE_REGISTRATION_REGISTER,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const moduleRegistration = createAsyncThunk(
  MODULE_REGISTRATION,
  async (params: PayloadCreatorParams<`${typeof API.MODULE_REGISTRATION}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.moduleRegistration(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const moduleRegistrationCreate = createAsyncThunk(
  MODULE_REGISTRATION_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.MODULE_REGISTRATION}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.moduleRegistrationCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const moduleRegistrationRegister = createAsyncThunk(
  MODULE_REGISTRATION_REGISTER,
  async (params: PayloadCreatorParams<`${typeof API.MODULE_REGISTRATION_REGISTER}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.moduleRegistrationRegister(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const moduleRegistrationDelete = createAsyncThunk(
  MODULE_REGISTRATION_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.MODULE_REGISTRATION}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.moduleRegistrationDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const moduleRegistrationList = createAsyncThunk(
  MODULE_REGISTRATION_LIST,
  async (params: PayloadCreatorParams<`${typeof API.MODULE_REGISTRATION}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.moduleRegistrationList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const moduleRegistrationAll = createAsyncThunk(
  MODULE_REGISTRATION_ALL,
  async (params: PayloadCreatorParams<`${typeof API.MODULE_REGISTRATION_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.moduleRegistrationAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const moduleRegistrationClear = createAction(`${MODULE_REGISTRATION}/clear`)

export const moduleRegistrationAllClear = createAction(`${MODULE_REGISTRATION_ALL}/clear`)

export const moduleRegistrationListClear = createAction(`${MODULE_REGISTRATION_LIST}/clear`)
